import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_sentryserver_da3c9982 from 'nuxt_plugin_sentryserver_da3c9982' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2d2841b7 from 'nuxt_plugin_sentryclient_2d2841b7' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_3170bd0d from 'nuxt_plugin_plugin_3170bd0d' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_dayjsplugin_8059ebfc from 'nuxt_plugin_dayjsplugin_8059ebfc' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_distpluginbd4e085e_0788cdc0 from 'nuxt_plugin_distpluginbd4e085e_0788cdc0' // Source: ./dist.plugin.bd4e085e.mjs (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../../../plugins/i18n (mode: 'all')
import nuxt_plugin_plugins_e476404e from 'nuxt_plugin_plugins_e476404e' // Source: ../../../plugins (mode: 'all')
import nuxt_plugin_veevalidation_26b22c31 from 'nuxt_plugin_veevalidation_26b22c31' // Source: ../../../plugins/vee-validation.js (mode: 'all')
import nuxt_plugin_chartjs_12dc9971 from 'nuxt_plugin_chartjs_12dc9971' // Source: ../../../plugins/chartjs (mode: 'all')
import nuxt_plugin_grmvuemodal_af27de76 from 'nuxt_plugin_grmvuemodal_af27de76' // Source: ../../../plugins/grm-vue-modal (mode: 'all')
import nuxt_plugin_vue2datepicker_04943087 from 'nuxt_plugin_vue2datepicker_04943087' // Source: ../../../plugins/vue2-datepicker (mode: 'all')
import nuxt_plugin_vue2perfectscrollbar_e694418a from 'nuxt_plugin_vue2perfectscrollbar_e694418a' // Source: ../../../plugins/vue2-perfect-scrollbar (mode: 'all')
import nuxt_plugin_vueflatpickrcomponent_3cee430b from 'nuxt_plugin_vueflatpickrcomponent_3cee430b' // Source: ../../../plugins/vue-flatpickr-component (mode: 'all')
import nuxt_plugin_meta_b2e31142 from 'nuxt_plugin_meta_b2e31142' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"구루미 올리고ㅤ|ㅤ우리만을 위한 No.1 캠스터디 서비스","htmlAttrs":{"lang":"ko"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0, user-scaleable=0"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fgh\u002Forioncactus\u002Fpretendard\u002Fdist\u002Fweb\u002Fstatic\u002Fpretendard.css"}],"script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-EN4YYG05E6","async":true,"defer":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=GTM-PJKN6D9","async":true,"defer":true}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_da3c9982 === 'function') {
    await nuxt_plugin_sentryserver_da3c9982(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2d2841b7 === 'function') {
    await nuxt_plugin_sentryclient_2d2841b7(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3170bd0d === 'function') {
    await nuxt_plugin_plugin_3170bd0d(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_8059ebfc === 'function') {
    await nuxt_plugin_dayjsplugin_8059ebfc(app.context, inject)
  }

  if (typeof nuxt_plugin_distpluginbd4e085e_0788cdc0 === 'function') {
    await nuxt_plugin_distpluginbd4e085e_0788cdc0(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_plugins_e476404e === 'function') {
    await nuxt_plugin_plugins_e476404e(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidation_26b22c31 === 'function') {
    await nuxt_plugin_veevalidation_26b22c31(app.context, inject)
  }

  if (typeof nuxt_plugin_chartjs_12dc9971 === 'function') {
    await nuxt_plugin_chartjs_12dc9971(app.context, inject)
  }

  if (typeof nuxt_plugin_grmvuemodal_af27de76 === 'function') {
    await nuxt_plugin_grmvuemodal_af27de76(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2datepicker_04943087 === 'function') {
    await nuxt_plugin_vue2datepicker_04943087(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2perfectscrollbar_e694418a === 'function') {
    await nuxt_plugin_vue2perfectscrollbar_e694418a(app.context, inject)
  }

  if (typeof nuxt_plugin_vueflatpickrcomponent_3cee430b === 'function') {
    await nuxt_plugin_vueflatpickrcomponent_3cee430b(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_b2e31142 === 'function') {
    await nuxt_plugin_meta_b2e31142(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
